import { Component, OnInit } from '@angular/core';
import { UserService } from 'src/app/user.service';
import { ActivatedRoute, Router } from '@angular/router';
import jwt_decode from 'jwt-decode';

@Component({
  selector: 'app-callback',
  templateUrl: './callback.component.html',
  styleUrls: ['./callback.component.scss']
})
export class CallbackComponent implements OnInit {
  loading = true;
  error = false;

  constructor(public userService: UserService) {}

  ngOnInit(): void {
    this.handleCallback();
  }

  saveToLocalStorage(user) {
    if (localStorage.getItem('user')) {
      const olduser = JSON.parse(localStorage.getItem('user'));

      olduser.username = user.username;
      olduser.token = user.token;

      localStorage.setItem('user', JSON.stringify(olduser));
    } else {
      localStorage.setItem('user', JSON.stringify(user));
    }
  }

   async handleCallback(): Promise<void> {
     try {
       await this.userService.handleLoginCallback();
       this.loading = false;
       
       // Check if there's a returnUrl (for user login flows)
       const returnUrl = localStorage.getItem('returnUrl');
       if (returnUrl) {
         // User login: redirect back to where they came from
         localStorage.removeItem('returnUrl');
         window.location.href = returnUrl;
       } else {
         // Admin login: redirect to administration panel (default behavior)
         // This will be handled by the router in handleLoginCallback
       }
     } catch (error) {
       console.error('Error handling callback:', error);
       this.loading = false;
       this.error = true;
     }
   }
}
